import { render, staticRenderFns } from "./settle-detail.vue?vue&type=template&id=27d121c8&scoped=true&"
import script from "./settle-detail.vue?vue&type=script&lang=js&"
export * from "./settle-detail.vue?vue&type=script&lang=js&"
import style0 from "./settle-detail.vue?vue&type=style&index=0&id=27d121c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d121c8",
  null
  
)

export default component.exports